import { render, staticRenderFns } from "./ArticlePaywall.vue?vue&type=template&id=3acfca6e&scoped=true"
import script from "./ArticlePaywall.vue?vue&type=script&lang=ts"
export * from "./ArticlePaywall.vue?vue&type=script&lang=ts"
import style0 from "./ArticlePaywall.vue?vue&type=style&index=0&id=3acfca6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acfca6e",
  null
  
)

export default component.exports